<div
    class="ag-floating-filter-full-body d-flex justify-content-center align-items-center"
    id="middle"
>
    <input
        #inputCk
        type="checkbox"
        [indeterminate]="checkbox.state == 'crossed'"
        [ngModel]="checkbox.state == 'checked'"
        (ngModelChange)="onChange(checkbox)"
    />
</div>
